import { render, staticRenderFns } from "./SearchCompanyItem.vue?vue&type=template&id=47cdfe78&scoped=true&"
import script from "./SearchCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./SearchCompanyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cdfe78",
  null
  
)

export default component.exports